<template>
    <div class="wiHBox">
        <div class="wihHeader">
            <i :class="wiHeaderData.taskSign"></i>
            <span class="wihhTitle">{{wiHeaderData.taskType}}</span>
        </div>
        <div class="wihContent">
            <div class="wihContent_top">
                <span :style="'color:'+ getColor()">+{{calculationNum}}%</span>
                <span id="wihCountNum2">{{wiHeaderData.taskHandleCount}}</span>
            </div>
            <div class="progressParent">
                <div class="topBox progressBox" :style="[{width: calculationNum+'%'}, {backgroundColor: getColor()}]"></div>
                <div class="bottomBox progressBox"></div>
                <!-- <el-progress :percentage="wiHeaderData.num" type="line" :stroke-width="10"></el-progress> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'webIndexHeader',
        props:{
            wiHeaderData:{
                type: Object,
                require: true
            }
        },
        data(){
            return {
                myData:{},
                colorList:['#00BFDD','#7874CE','#FFAB00','#E64C66'],    //一级，二级，三级，四级
                calculationNum:0,
                headerOwn:{},

            }
        },
        watch:{
           wiHeaderData:{
               handler(v){
                   if(v) {
                       this.getWidth()
                       this.getColor()
                   }
               }
           } 
        },
        methods:{
            //获取颜色
            getColor(){
                let num = parseFloat(this.calculationNum)
                 //小到大0-100颜色升序
                switch(true){
                    case 0 <= num && num <= 30 : 
                        return this.colorList[0]
                    case 30 < num && num <= 50 : 
                        return this.colorList[1]
                    case 50 < num && num <= 70 : 
                        return this.colorList[2]
                    default : 
                        return this.colorList[3]
                }
            },
            //获取宽度
            getWidth(){
                // let allNum = parseFloat(this.wiHeaderData.taskAllCount)
                let allNum = parseFloat(this.wiHeaderData.allTaskHandleCount)
                let num = parseFloat(this.wiHeaderData.taskHandleCount)
                if(num<=0 || allNum<=0){
                    this.calculationNum = 0
                    return this.calculationNum
                }
                this.calculationNum = Math.ceil(num/allNum*100)
                return this.calculationNum
            },
        },
        created(){
            this.getWidth()
        },
    }
</script>

<style scoped>
@import url('../assets/fonts/fonts.css');
.wiHBox{
    box-sizing: border-box;
    height: 140px;
    padding: 20px;
    background-color: #FFFFFF;  
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.wihHeader{
    flex: 1;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
}
.wihhTitle{
   font-size: 1.2rem;
   font-weight: bold;
   color: #666666;
}
.wihContent{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
}
.wihContent_top{
    font-family: "DIN_Regular";
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: baseline;
}
.progressParent{
    width: 100%;
    position: relative;
}
.progressBox{
    height: 11px;
    border-radius: 5px;
    position: absolute;
    top: 0;
    left: 0;
}
.topBox{
    z-index: 9;
}
.bottomBox{
    width: 100%;
    background-color: #F2F2F2;
    z-index: 1;
}
.wihContent #wihCountNum2{
    font-size:1.5rem;
    color:#333;
}
</style>